<template>
    <div>
        <div>
            <div class="form-group text-right">
                <button class="btn btn-primary"  data-toggle="modal" data-target="#modalnew" ><i class="fas fa-plus"></i> Jauna loma</button>
            </div>
        </div>
        <div class="content">
            <table class="table table-responsive-xl table-hover roles-table">
                <thead class="bg-light font-weight-bold">
                    <tr>
                        <td>Nosaukums</td>
                        <td>Programmatiskais nosaukums</td>
                        <td>Apraksts</td>
                        <td>Darbības</td>
                    </tr>
                </thead>
            <tbody>
                <role-component v-for="role in roles" :key="role.id" :role="role" :permissions="permissions" :groups="groups"></role-component>
            </tbody>
            </table>
        </div>
        <div class="modal fade" tabindex="-1"  id="modalnew" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna loma</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="display_name">Nosaukums</label>
                                    <input type="text" v-model="display_name" class="form-control" :class="{'is-invalid':errors && ( 'display_name' in errors)}" >
                                    <small class="text-danger" v-if="errors && errors.display_name">{{errors.display_name[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="name">Programmatiskais nosaukums</label>
                                    <input type="text" v-model="name" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}" >
                                    <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                    <small class="text-muted" v-else>Nosaukums bez atstarpēm, mīkstinājuma un garumzīmēm</small>
                                </div>
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <input type="text" v-model="description" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}" >
                                    <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <input type="button" class="btn btn-primary" value="Pievienot" @click="newRole()" v-if="loading == false">
                        <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>

    export default {
        props:['roles','permissions','groups'],
        mounted()
        {
            var that = this;
             EventBus.$on('roles_updated', (roles) =>{
                that.roles = roles;

            });
        },
        data()
        {
            return {
                loading:false,
                name:"",
                display_name: "",
                description:"",
                errors:null,
            }
        },
        methods: {

            newRole()
            {
                var that = this;
                that.loading = true;
                axios.post('/dashboard/api/roles',{
                    name: this.name,
                    display_name:this.display_name,
                    description:this.description
                }).then(response => {
                     EventBus.$emit('roles_updated', response.data.roles);
                    that.$toast.open(response.data.message);
                    $(that.$refs.vuemodal).modal('hide');
                    that.errors = response.data.errors;
                    that.loading = false;
                })
            }
        }
    }

</script>
<style lang="scss" scoped>
    .roles-table{
        width:100%;
    }
</style>

